export const UPDATE_FIELD_VALUE = 'UPDATE_FIELD_VALUE';
export const UPDATE_CUSTOM_FIELD_VALUE = 'UPDATE_CUSTOM_FIELD_VALUE';
export const SET_NEW_STATE = 'SET_NEW_STATE';
